import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.657 2H6.344a2 2 0 0 0-1.749 1.029l-2.222 4a2 2 0 0 0 0 1.942l2.222 4A2 2 0 0 0 6.344 14H11.2a2 2 0 0 0 1.828-1.188l1.734-3.9a2 2 0 0 0-.08-1.784l-2.277-4.1A2 2 0 0 0 10.657 2z"
      stroke="#007AFF"
    />
    <circle cx={8.5} cy={8} r={2.833} stroke="#007AFF" />
  </svg>
);
const Memo = memo(SvgSettings);
export default Memo;
